<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Text } from '~ds/components/ui/typography';

import { EDUCATORS_ROUTE_LOGIN, EDUCATORS_ROUTE_SIGNUP } from '~/constants/routes/educators';
import { useConfigStore } from '~/stores/config';

const emit = defineEmits<{
  navigate: [];
}>();

const { t } = useI18n();
const route = useRoute();
const configStore = useConfigStore();
const analytics = useAnalyticsService();

const createAccount = () => {
  analytics.track(EVENTS.SCHOOLS_LANDING_CTA_CLICKED, { cta: 'drawer_create_account', page: route.path });
  emit('navigate');
};
</script>

<template>
  <div v-if="configStore.teacherRegistrationOpen" class="flex flex-col items-center gap-4">
    <Button
      size="lg"
      class="w-full"
      as-child
    >
      <NuxtLink
        :to="EDUCATORS_ROUTE_SIGNUP"
        data-testid="schools-drawer-create-account"
        @click="createAccount"
      >
        {{ t('schools.landing.nav.createAccount') }}
      </NuxtLink>
    </Button>
    <Text size="sm" class="text-center text-muted-foreground">
      {{ t('schools.landing.nav.haveAccount') }}
      <Button
        variant="link"
        as-child
        class="h-auto p-0 underline"
      >
        <NuxtLink
          :to="EDUCATORS_ROUTE_LOGIN"
          data-testid="schools-drawer-sign-in"
          @click="emit('navigate')"
        >
          {{ t('unified.nav.signIn') }}
        </NuxtLink>
      </Button>
    </Text>
  </div>
</template>
